import { useEffect, useState } from "react";

export const useVideoVisibility = () => {
  const [pageVisible, setPageVisible] = useState(() => !document.hidden);

  useEffect(() => {
    const visibilityChanged = () => setPageVisible(!document.hidden);
    document.addEventListener("visibilitychange", visibilityChanged);
    return () => {
      document.removeEventListener("visibilitychange", visibilityChanged);
    };
  }, []);

  return { pageVisible };
};